export const sliderData = [
  {
    id: 1,
    background: '',
    backgroundColor: 'pigeon-post',
    content: 'Technology',
    description:
      "We're out of old, non-supported tech stack. You'll be building software based on:",
    color: '',
    images: [
      'Symfony',
      'Java',
      'Angular',
      'Python',
      'Php',
      'Android',
      'Spring',
      'Css',
      'Ios',
      'React',
      'NodeJS',
      'Html',
    ],
  },
  {
    id: 2,
    background: 'Design',
    backgroundColor: '',
    content: 'Processes help us work smarter',
    description:
      'Lean Startup and Scrum go hand in hand here to help us achieve better results',
    color: '',
    images: [],
  },
  {
    id: 3,
    background: 'Teal',
    backgroundColor: '',
    content: 'Teal workspace',
    description:
      'Our offices design is meant to empower our creativity, boost teamwork and keep us united',
    color: 'white',
    images: [],
  },
  {
    id: 4,
    background: '',
    backgroundColor: 'mine-shaft',
    content: 'Individual career path',
    description:
      'No managers breathing down your neck, room for your initiatives, development opportunities, constant and honest feedback.',
    color: 'white',
    images: [],
  },
];
